// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-header {
  border-bottom: 1px solid #dde1ef;
  z-index: 99;
  height: 70px;
  padding: 0 15px 0 70px;
  width: 100%;
}
@media (min-width: 1200px) {
  .main-header {
    width: calc(100% - 250px);
  }
}
.main-header .nav-link {
  color: #070f1c;
}
.main-header-right {
  gap: 12px;
}
.main-header-right-icon {
  border-radius: 50%;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main-header-right-icon:hover {
  background-color: gray;
}
.main-header-right-dropdown .dropdown-toggle {
  font-size: 13px;
}
.main-header-right-dropdown .dropdown-item:hover {
  background-color: #f0f4ff;
}
.main-header-right-dropdown-list {
  border-radius: 0.3rem;
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border: 1px solid #dde1ef;
  font-size: 13px;
  min-width: 165px;
}
.main-header-right-dropdown-list .dropdown-item {
  display: flex;
  align-items: center;
  gap: 5px;
  color: #000;
}
.main-header-right-dropdown-list svg {
  width: 16px;
  height: 16px;
}
.main-header-right-dropdown-list-logout {
  color: #f77d7d !important;
}`, "",{"version":3,"sources":["webpack://./src/components/common/header/header.scss","webpack://./src/assets/css/variables.scss"],"names":[],"mappings":"AAKA;EACE,gCAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,WAAA;AAJF;AAKE;EANF;IAOI,yBAAA;EAFF;AACF;AAGE;EACE,cCZU;ADWd;AAGE;EACE,SAAA;AADJ;AAEI;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAN;AACM;EACE,sBAAA;AACR;AAGM;EACE,eAAA;AADR;AAIQ;EACE,yBC5BA;AD0BV;AAKM;EACE,qBAAA;EACA,6CAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;AAHR;AAIQ;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,WAAA;AAFV;AAIQ;EACE,WAAA;EACA,YAAA;AAFV;AAIQ;EACE,yBAAA;AAFV","sourcesContent":["\n\n@import \"../../../assets/css/variables.scss\";\n\n\n.main-header{\n  border-bottom: 1px solid #dde1ef;\n  z-index: 99;\n  height: 70px;\n  padding: 0 15px 0 70px;\n  width: 100%;\n  @media(min-width: 1200px) {\n    width: calc(100% - $sidebarWidth);\n  }\n  .nav-link{\n    color: $dark-color;\n  }\n  &-right{\n    gap: 12px;\n    &-icon{\n      border-radius: 50%;\n      height: 32px;\n      width: 32px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      &:hover{\n        background-color: gray;\n      }\n    }\n    &-dropdown{\n      .dropdown-toggle{\n        font-size: 13px;\n      }\n      .dropdown-item{\n        &:hover{\n          background-color: $hoverbg;\n        }\n      }\n      &-list{\n        border-radius: 0.3rem;\n        box-shadow: 0 5px 10px rgba(30,32,37,.12);\n        border: 1px solid #dde1ef;\n        font-size: 13px;\n        min-width: 165px;\n        .dropdown-item{\n          display: flex;\n          align-items: center;\n          gap: 5px;\n          color: #000;\n        }\n        svg{\n          width: 16px;\n          height: 16px;\n        }\n        &-logout{\n          color: #f77d7d !important;\n        }\n      }\n    }\n  }\n}","\n\n$golden-color : #e7d993;\n$dark-color : #070f1c;\n$white-color : #fff;\n$gray-color: #a9b0b3;\n$sidebarWidth: 250px;\n$headerHeight: 70px;\n$hoverbg: #f0f4ff;\n$mainBlue: #12265f;\n$dangerRed: #FF6961;\n$orange:  #fd7e14;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
